$('.tego-displayinput').displayinput();